import { FolderableType } from 'apps/folders/static/enums/folderable-type.enum';
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import { TalkingPointTextEditModalComponent } from 'NewAngular/features/components/modals/talking-point-text-edit-modal/talking-point-text-edit-modal.component';
import { ContentItemBase } from 'FoldersApp/directives/content-item-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/item-selection.service";
import * as i2 from "@angular/common";
import * as i3 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i4 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/modals/talking-point-text-edit-modal/talking-point-text-edit-modal.component";
import * as i8 from "../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
const _c0 = a0 => ({ "text-blue": a0 });
function TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "div", 6);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template, 1, 0, "div", 8);
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 3, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 6, folder_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 6 : -1);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-talking-points-select-saved-list-item", 9);
} if (rf & 2) {
    const folderable_r3 = ctx.folderable;
    const ancestorInfo_r4 = ctx.ancestorInfo;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("folderable", folderable_r3)("ancestorInfo", ancestorInfo_r4)("isMultiSelect", ctx_r1.isMultiSelect)("maxItems", ctx_r1.maxItems);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span");
    i0.ɵɵtext(2, "There are no talking points in this folder.");
    i0.ɵɵelementEnd()();
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 4, 0);
    i0.ɵɵtemplate(2, TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_2_Template, 7, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_4_Template, 1, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, TalkingPointsSelectSavedListItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r5 = i0.ɵɵreference(3);
    const listItemFragment_r6 = i0.ɵɵreference(5);
    const emptyFolderFragment_r7 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r1.folderable)("ancestorInfo", ctx_r1.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r5)("listItemFragment", listItemFragment_r6)("emptyFolderFragment", emptyFolderFragment_r7);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵlistener("click", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_11_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.itemSelectionService.toggleSelectedItem(ctx_r1.talkingPoint)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("textContent", ctx_r1.talkingPoint.name)("disabled", !ctx_r1.isSelected && !ctx_r1.itemSelectionEnabled);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵlistener("click", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.itemSelectionService.toggleSelectedItem(ctx_r1.talkingPoint)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", !ctx_r1.isSelected && !ctx_r1.itemSelectionEnabled)("textContent", ctx_r1.talkingPoint.name);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 32);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-remove-circle");
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 33);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r1.itemSelectionEnabled))("name", "icon-add-circle");
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.itemSelectionService.toggleSelectedItem(ctx_r1.talkingPoint)); });
    i0.ɵɵelementStart(1, "div", 30)(2, "button", 31);
    i0.ɵɵconditionalCreate(3, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Conditional_3_Template, 1, 1, ":svg:svg", 32)(4, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Conditional_4_Template, 1, 4, ":svg:svg", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", !ctx_r1.isSelected && !ctx_r1.itemSelectionEnabled);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isSelected ? 3 : 4);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "label", 15)(3, "input", 16);
    i0.ɵɵlistener("click", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.bulkActionSelectionService.toggleSelectedItem(ctx_r1.folderable.resourceType, ctx_r1.talkingPoint.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 18)(6, "div", 19)(7, "div", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 21);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 22);
    i0.ɵɵtext(10, "tp");
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(11, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_11_Template, 1, 2, "span", 23)(12, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template, 1, 2, "a", 24);
    i0.ɵɵelementStart(13, "button", 25);
    i0.ɵɵlistener("click", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.openEditModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(14, "svg", 21);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(15, "div", 5);
    i0.ɵɵelement(16, "div", 6);
    i0.ɵɵpipe(17, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 7);
    i0.ɵɵelement(19, "div", 6);
    i0.ɵɵpipe(20, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(21, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_21_Template, 5, 2, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r1.isBulkSelected && ctx_r1.isBulkActionMode || ctx_r1.isSelected && !ctx_r1.isBulkActionMode);
    i0.ɵɵproperty("folderable", ctx_r1.folderable)("ancestorInfo", ctx_r1.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isBulkSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 11 : 12);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-info");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(17, 12, ctx_r1.talkingPoint.user_modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(20, 15, ctx_r1.talkingPoint));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 21 : -1);
} }
function TalkingPointsSelectSavedListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, TalkingPointsSelectSavedListItemComponent_Conditional_1_Conditional_0_Template, 22, 17, "div", 11);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "ycn-talking-point-text-edit-modal", 12);
    i0.ɵɵlistener("textSaved", function TalkingPointsSelectSavedListItemComponent_Conditional_1_Template_ycn_talking_point_text_edit_modal_textSaved_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.textSaved($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 3, ctx_r1.bulkActionSelectionService.idsByResourceType$) ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("talkingPoint", ctx_r1.talkingPoint)("defaultText", ctx_r1.defaultText);
} }
export class TalkingPointsSelectSavedListItemComponent extends ContentItemBase {
    get talkingPoint() {
        return this.folderable.item;
    }
    constructor(itemSelectionService) {
        super();
        this.itemSelectionService = itemSelectionService;
        this.isMultiSelect = false;
        this.FolderItemType = FolderableType;
    }
    ngOnInit() {
        this.defaultText = this.folderable.item.proposal_text;
    }
    openEditModal() {
        const selectedItem = this.itemSelectionService.getSelectedItem(this.folderable.item);
        if (selectedItem && selectedItem.proposal_text != null) {
            this.folderable.item.proposal_text = selectedItem.proposal_text;
        }
        this.talkingPointTextEditModal.openModal();
    }
    textSaved(newText) {
        this.folderable.item.proposal_text = newText;
        this.itemSelectionService.updateSelectItem(this.folderable.item);
    }
    get itemSelectionEnabled() {
        return this.maxItems > this.itemSelectionService.numSelectedItems;
    }
    get isSelected() {
        return this.itemSelectionService.isSelected(this.talkingPoint);
    }
    fileDropdownHandler() { }
}
TalkingPointsSelectSavedListItemComponent.ɵfac = function TalkingPointsSelectSavedListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsSelectSavedListItemComponent)(i0.ɵɵdirectiveInject(i1.ItemSelectionService)); };
TalkingPointsSelectSavedListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointsSelectSavedListItemComponent, selectors: [["ycn-talking-points-select-saved-list-item"]], viewQuery: function TalkingPointsSelectSavedListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TalkingPointTextEditModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.talkingPointTextEditModal = _t.first);
    } }, inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo", isMultiSelect: "isMultiSelect", maxItems: "maxItems" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [1, "td", "file-td-grip", "col-3", "col-lg-1"], [3, "folderable", "ancestorInfo", "isMultiSelect", "maxItems"], [1, "get-started-small", "flex-auto"], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], [3, "textSaved", "talkingPoint", "defaultText"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], ["data-test-id", "talking-point-saved-list-item", 1, "td", "file-td-name"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], ["draggable", "false", 1, "file-icon", "file-tp"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["draggable", "false", "ycnDisabled", "", 1, "file-title", "cursor-pointer", 3, "textContent", "disabled"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "disabled", "textContent"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "vertical-align-middle", "ml-1", 3, "click"], ["ycnDisabled", "", 1, "td", "file-td-grip", "col-3", "col-lg-1", 3, "disabled"], ["draggable", "false", "ycnDisabled", "", 1, "file-title", "cursor-pointer", 3, "click", "textContent", "disabled"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "click", "disabled", "textContent"], ["ycnDisabled", "", 1, "td", "file-td-grip", "col-3", "col-lg-1", 3, "click", "disabled"], [1, "pt-1", "pb-1"], ["data-test-id", "add-talking-point-button", 1, "btn", "btn-xs", "btn-circle", "btn-transparent"], ["ycnIcon", "", 1, "icon-remove-circle", "fill-current", "text-blue", 3, "name"], ["ycnIcon", "", 1, "icon-remove-circle", "fill-current", 3, "ngClass", "name"]], template: function TalkingPointsSelectSavedListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, TalkingPointsSelectSavedListItemComponent_Conditional_0_Template, 8, 5)(1, TalkingPointsSelectSavedListItemComponent_Conditional_1_Template, 3, 5);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i2.NgClass, i3.FolderableDirective, i4.FolderBaseComponent, i5.IconDirective, i6.DisabledDirective, i7.TalkingPointTextEditModalComponent, TalkingPointsSelectSavedListItemComponent, i2.AsyncPipe, i2.DatePipe, i8.GetOwnerDisplayName], encapsulation: 2 });
